import { Box, Text } from '@wix/design-system';
import React from 'react';
export const InaccessibleLayoutRuleHeader = _ref => {
  let {
    label
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    alignSelf: "center",
    cursor: "pointer",
    width: "216px"
  }, /*#__PURE__*/React.createElement(Box, {
    height: "32px",
    verticalAlign: "middle",
    width: "214px"
  }, /*#__PURE__*/React.createElement(Text, {
    maxLines: 2,
    size: "tiny",
    weight: "normal",
    zIndex: 1,
    ellipsis: true
  }, label)));
};
//# sourceMappingURL=inaccessible-layout-rule-header.js.map